export default "__VITE_ASSET__dVh8d9zl__"